
import React from "react";
import Counselling from "../../Assets/Images/Counselling5.jpg";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const handleRoute = (route) => {
    navigate(route);
  };

  return (
    <div
      className="h-auto lg:h-screen bg-cover bg-center relative shadow-lg px-[5%] py-10"
      style={{ backgroundImage: `url(${Counselling})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />

      {/* Content */}
      <div className="relative z-10 flex flex-col lg:flex-row justify-between items-start gap-10">
        {/* Left: Main Text */}
        <div className="w-full lg:w-1/2 mt-10">
          <p className="bg-gradient-to-r from-primary to-primary/25 text-white px-4 py-2 rounded-lg w-max">
            No.1 Mental Health Support Platform
          </p>
          <p className="mt-6 text-white font-bold text-3xl sm:text-4xl lg:text-5xl font-serif leading-tight">
            Our Treatment Your <br />
            <span className="text-accent">Recovery</span>
          </p>
          <p className="mt-6 text-white/85 text-base sm:text-lg leading-relaxed">
            Feeling stressed, anxious, or down? Take our free online test to
            check your mood and anxiety levels. Access our evidence-based
            program designed to help you feel better and improve your mental well-being.
          </p>
          <div className="flex mt-8 gap-4">
            <button
              onClick={() => handleRoute("/getstarted")}
              className="bg-primary text-white px-4 py-2 rounded-md hover:scale-95 transition"
            >
              Get Started
            </button>
            <button
              onClick={() => handleRoute("/getstarted")}
              className="border border-primary text-accent px-4 py-2 rounded-md hover:scale-95 transition"
            >
              Signup
            </button>
          </div>
        </div>

        {/* Right: Feature Buttons */}
        {/* <div className="w-full lg:w-[40%] flex flex-col gap-4 bg-primary/30 backdrop-blur-md p-6 rounded-md">
          {[
            "😥 Emotional Support",
            "😧 Improved Coping Skills",
            "😩 Stress Reduction",
            "🙂 Healthy Lifestyle Changes",
          ].map((text, idx) => (
            <button
              key={idx}
              className="bg-accent/60 hover:bg-accent text-white px-4 py-2 rounded-lg w-full text-left"
            >
              {text}
            </button>
          ))}
        </div> */}
        {/* Right: Feature Buttons */}
<div className="w-full lg:w-auto flex justify-center">
  <div className="lg:absolute lg:top-1/2 lg:right-[10%] lg:translate-y-[-50%] bg-primary/30 backdrop-blur-md p-6 rounded-md w-full max-w-xs">
    {[
      "😥 Emotional Support",
      "😧 Improved Coping Skills",
      "😩 Stress Reduction",
      "🙂 Healthy Lifestyle Changes",
    ].map((text, idx) => (
      <button
        key={idx}
        className="bg-accent/60 hover:bg-accent text-white px-4 py-2 rounded-lg w-full text-left mt-2"
      >
        {text}
      </button>
    ))}
  </div>
</div>

      </div>
    </div>
  );
};

export default Hero;
